"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pipes = void 0;
const days_since_pipe_1 = require("./days-since.pipe");
const parse_float_pipe_1 = require("./parse-float.pipe");
const round_pipe_1 = require("./round.pipe");
const safe_1 = require("./safe");
exports.Pipes = [
    round_pipe_1.RoundUpPipe,
    days_since_pipe_1.DaysSincePipe,
    parse_float_pipe_1.ParseFloatPipe,
    safe_1.SafePipe,
];
